export default __webpack_public_path__ + "static/media/GT-Pressura-Pro-Bold.aaab9d84.ttf";